import { Tooltip, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  AttachmentIcon,
  GPTIcon,
  GridIcon,
  KotiIcon,
  ListIcon,
  LomaIcon,
  ReportIcon,
} from "src/components/icons/NavIcons";
import { useUserData } from "src/context/userContext";
import styled from "styled-components";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useDarkModeData } from "src/context/DarkModeContext";
import { SearchIcon } from "src/components/icons/SearchIcons";
import { rgba } from "polished";
import { AdminPanelIcon } from "src/components/icons/StepIcons";
import { WorkIcon } from "src/components/icons/ReportIcons";
import PropTypes from "prop-types";
import { MessageIcon } from "src/components/icons/MediaIcons";

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  transition: all 0.3s ease-in-out;
  border-radius: 1px;
  padding: 4px;
  cursor: pointer;
  background-color: ${(props) => (props.$isActive ? "rgba(128, 128, 128, 0.3)" : "transparent")};
  border: ${(props) =>
    props.$isActive ? "1px solid rgba(128, 128, 128, 0.7)" : "1px solid transparent"};
  border-bottom: ${({ $theme, $isActive }) =>
    $isActive ? "4px solid " + rgba($theme.palette.secondary.main, 1) : "4px solid transparent"};
  &:hover {
    transition: all 0.3s ease-in-out;
    border: 1px solid rgba(128, 128, 128, 0.5);
    border-bottom: ${({ $theme, $isActive }) =>
      $isActive ? "4px solid " + rgba($theme.palette.secondary.main, 1) : "4px solid transparent"};
    background-color: ${({ $theme }) => rgba($theme.palette.secondary.main, 0.3)};
  }
`;

const styles = {
  main: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
    flexWrap: "wrap",
    justifyContent: "space-evenly",
  },
};

const iconSizes = {
  small: "0.8em",
  medium: "1.1em",
  large: "1.5em",
};

const fontSizes = {
  small: "0.6em",
  medium: "0.7em",
  large: "1em",
};

export default function SiteAppBarNavigationIcons({
  size = "medium",
  onlyWide = false,
  onClick = () => {},
}) {
  const theme = useTheme();
  const { darkMode, doSetDarkMode } = useDarkModeData();
  const { isLoggedIn, userAsiakas, auth } = useUserData();
  const navigate = useNavigate();

  const handleClick = (url) => {
    onClick(url);
    navigate(url);
  };

  if (!isLoggedIn || !auth.isLoaded) return null;

  return (
    <div style={styles.main}>
      {auth.page.koti.read &&
        renderIcon({
          icon: <KotiIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Koti",
          desciption: "Kotisivulle",
          url: "/koti",
          onClick: () => handleClick("/koti"),
          theme: theme,
          onlyWide: false,
        })}
      {auth.page.tyot.read &&
        renderIcon({
          icon: <WorkIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Työt",
          desciption: "Omat työt ja tehtävät",
          url: "/tyot",
          onClick: () => handleClick("/tyot"),
          theme: theme,
          onlyWide: false,
        })}
      {auth.page.list.read &&
        renderIcon({
          icon: <ListIcon style={{ fontSize: iconSizes[size] }} />,
          label: "List",
          desciption: "Tilauslista",
          url: "/list",
          onClick: () => handleClick("/list"),
          theme: theme,
          onlyWide: onlyWide,
        })}
      {auth.page.grid.read &&
        renderIcon({
          icon: <GridIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Grid",
          desciption: "Tilauskalenteri",
          url: "/grid",
          onClick: () => handleClick("/grid"),
          theme: theme,
          onlyWide: false,
        })}
      {auth.page.raport.read &&
        renderIcon({
          icon: <ReportIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Raport",
          desciption: "Raportit",
          url: "/raport, /raportit",
          onClick: () => handleClick("/raport"),
          theme: theme,
          onlyWide: false,
        })}
      {auth.page.loma.read &&
        renderIcon({
          icon: <LomaIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Lomat",
          desciption: "Poissaolot ja lomat",
          url: "/loma, /lomat",
          onClick: () => handleClick("/loma"),
          theme: theme,
          onlyWide: onlyWide,
        })}
      {auth.page.liite.list &&
        renderIcon({
          icon: <AttachmentIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Liite",
          desciption: "Liitetiedostot",
          url: "/attachments, /liitteet, /liite",
          onClick: () => handleClick("/liite"),
          theme: theme,
          onlyWide: onlyWide,
        })}
      {auth.page.ai.read &&
        renderIcon({
          icon: <GPTIcon fontSize={iconSizes[size]} />,
          label: "AI",
          desciption: "Tekoäly",
          url: "/ai",
          onClick: () => handleClick("/ai"),
          theme: theme,
          onlyWide: true,
        })}
      {auth.page.haku.read &&
        renderIcon({
          icon: <SearchIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Haku",
          desciption: "Haku",
          url: "/haku, /search",
          onClick: () => handleClick("/haku"),
          theme: theme,
          onlyWide: onlyWide,
        })}
      {
        // auth.page.user.read &&
        //   renderIcon({
        //     icon: <ProfileIcon style={{ fontSize: iconSizes[size] }} />,
        //     label: user.personFirstName,
        //     desciption: "Henkilötiedot",
        //     url: "/profile",
        //     onClick: () => handleClick("/profile"),
        //     theme: theme,
        //     onlyWide: onlyWide,
        //   })
      }
      {
        // // eslint-disable-next-line no-constant-binary-expression
        // auth.page.userAsiakas.read &&
        //   renderIcon({
        //     icon: <AsiakasIcon style={{ fontSize: iconSizes[size] }} />,
        //     label: "Yritys",
        //     desciption: userAsiakas?.asiakasNimi,
        //     url: "/asiakas",
        //     onClick: () => handleClick("/asiakas/" + userAsiakas?.asiakasId),
        //     theme: theme,
        //     onlyWide: onlyWide,
        //   })
      }
      {auth.page.admin.read &&
        userAsiakas &&
        renderIcon({
          icon: <AdminPanelIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Admin",
          desciption: "Admin",
          url: "/admin",
          onClick: () => handleClick("/admin"),
          theme: theme,
          onlyWide: onlyWide,
        })}
      {auth.page.messages.read &&
        renderIcon({
          icon: <MessageIcon style={{ fontSize: iconSizes[size] }} />,
          label: "Viestit",
          desciption: "Viestit",
          url: "/messages",
          onClick: () => handleClick("/messages"),
          theme: theme,
          onlyWide: onlyWide,
        })}
      {renderIcon({
        icon: darkMode ? (
          <Brightness7Icon style={{ fontSize: iconSizes[size] }} />
        ) : (
          <Brightness4Icon style={{ fontSize: iconSizes[size] }} />
        ),
        label: darkMode ? "Tumma" : "Vaalea",
        desciption: "Vaihda teema",
        url: "/darkmode",
        onClick: () => doSetDarkMode(!darkMode),
        theme: theme,
        onlyWide: false,
      })}
    </div>
  );

  function renderIcon({ icon, label, desciption, url, onClick, theme, onlyWide }) {
    const urls = url.split(",");
    const isActive =
      urls.some((u) => u.includes(window.location.pathname)) && window.location.pathname.length > 2;
    return (
      <div className={onlyWide ? "onlyWide" : ""}>
        <Tooltip title={desciption} disableInteractive>
          <IconContainer onClick={onClick} $isActive={isActive} $theme={theme}>
            {icon}
            <Typography variant="caption" sx={{ fontSize: fontSizes[size] }}>
              {label}
            </Typography>
          </IconContainer>
        </Tooltip>
      </div>
    );
  }
}

SiteAppBarNavigationIcons.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  onlyWide: PropTypes.bool,
  onClick: PropTypes.func,
};
